import React, { createContext, useContext } from 'react';
interface PricingContextType {
  price: string;
  priceValue: number;
  currency: string;
  currencySymbol: string;
  isEurope: boolean;
  isLoading: boolean;
}
// Default context values
const PricingContext = createContext<PricingContextType>({
  price: '$399',
  priceValue: 399,
  currency: 'USD',
  currencySymbol: '$',
  isEurope: false,
  isLoading: false
});
/** Hook to consume the PricingContext */
export function usePricing(): PricingContextType {
  return useContext(PricingContext);
}
/** Provider component for PricingContext */
export function PricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const value: PricingContextType = {
    price: '$399',
    priceValue: 399,
    currency: 'USD',
    currencySymbol: '$',
    isEurope: false,
    isLoading: false
  };
  return <PricingContext.Provider value={value} data-id="element-534">{children}</PricingContext.Provider>;
}